import { render } from "./MenuFilter.vue?vue&type=template&id=001a3463&scoped=true"
import script from "./MenuFilter.vue?vue&type=script&lang=js"
export * from "./MenuFilter.vue?vue&type=script&lang=js"

import "./MenuFilter.vue?vue&type=style&index=0&id=001a3463&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001a3463"]])

export default __exports__